import React, { Component } from "react";
import Loader from "../utils/loader";
import userService from "../services/userService";
import teamService from "../services/teamService";
import Swal from "sweetalert2";
import TeamCard from "./Cards/Teamcard";
import { toast, ToastContainer } from "react-toastify";
import PaginatioN from "react-js-pagination";
import { paginate } from "../utils/paginate";
import "./teamMembers.css";
import Avatars from "./Avatar";
import team from "../static/noteams.png";
import isEmptyObject from "../utils/isEmptyObject";
import { connect } from "react-redux";
import { setCurrentUser } from "../redux/user/user.actions";
import { ReactMultiEmail, isEmail } from "react-multi-email";
import "react-multi-email/style.css";
import _ from "lodash";
import ReactTour from "./ReactTour";
import { withRouter } from "react-router-dom";
import ChatServices from "../services/ChatServices";
import BasicAvatar from "./BasicAvatar";
import { ChatContext } from "../contexts/ChatContext";
import { addUserLogs } from "../services/userLogServices";
import SubscriptionRequired from "./SubscriptionRequired";

// MUI Imports
import {
  Box,
  Card,
  CardContent,
  CardActions,
  TextField,
  Button,
  Typography,
  Divider,
  Popover,
  Tooltip,
  Badge,
  Avatar,
  Checkbox,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  Chip,
  Paper,
  InputAdornment,
  Fade,
  Zoom,
} from "@mui/material";
import Grid2 from "@mui/material/Unstable_Grid2";
import {
  Add as AddIcon,
  PersonAdd as PersonAddIcon,
  Search as SearchIcon,
  Delete as DeleteIcon,
  Chat as ChatIcon,
  Group as GroupIcon,
  ExitToApp as ExitToAppIcon,
  Close as CloseIcon,
  HelpOutline as HelpIcon,
  MoreVert as MoreVertIcon,
  Person as PersonIcon,
  ArrowBack as ArrowBackIcon,
  ArrowForward as ArrowForwardIcon,
  FirstPage as FirstPageIcon,
  LastPage as LastPageIcon,
} from "@mui/icons-material";
import { styled, alpha } from "@mui/material/styles";

// Styled Components
const StyledCard = styled(Card)(({ theme }) => ({
  height: "100%",
  display: "flex",
  flexDirection: "column",
  transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
  borderRadius: 16,
  overflow: "hidden",
  "&:hover": {
    transform: "translateY(-8px)",
    boxShadow: theme.shadows[12],
  },
}));

const GradientCard = styled(StyledCard)(({ theme }) => ({
  background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.dark} 100%)`,
  color: theme.palette.primary.contrastText,
}));

const SearchTextField = styled(TextField)(({ theme }) => ({
  "& .MuiOutlinedInput-root": {
    borderRadius: 50,
    backgroundColor: alpha(theme.palette.common.white, 0.15),
    "&:hover": {
      backgroundColor: alpha(theme.palette.common.white, 0.25),
    },
    "&.Mui-focused": {
      backgroundColor: alpha(theme.palette.common.white, 0.25),
    },
  },
}));


const ActionButton = styled(Button)(({ theme }) => ({
  borderRadius: "20px ! important",
  width: "50% !important",
  textTransform: "none",
  fontWeight: 600,
  boxShadow: theme.shadows[2],
  backgroundColor: "#e7e3e3ff !important", // Added background color with !important
  color: "#667eea !important", // Added text color with !important
  "&:hover": {
    boxShadow: theme.shadows[6],
    backgroundColor: "#c6c3c3ff !important", // Hover background with !important
  },
}));

const colors = [
  "#bff603",
  "yellow",
  "#80d4ff",
  "orange",
  "#ff8b94",
  "#d3ffce",
  "#9bb7d4",
  "#ffdb58",
  "#f1a7fe",
  "#ff6961",
  "#ffb347",
  "#add8e6",
  "#a0bfe6",
  "#89cff0",
  "#4f86f7",
  "#67e6ec",
  "#7fffd4",
  "#77dd77",
  "#b19cd9",
  "#ff9999",
];

const steps = [
  {
    selector: ".first-step",
    content: "Create new group to add members",
    position: "left",
  },
  {
    selector: ".second-step",
    content: "Enter email to send invite request to member",
    position: "bottom",
  },
];

const stepsone = [
  {
    selector: ".first-step",
    content: "Create new group to add members",
    position: "left",
  },
  {
    selector: ".second-step",
    content: "Enter email to send invite request to member",
    position: "bottom",
  },
  {
    selector: ".third-step",
    content: "Click to view/add members to the group",
    position: "bottom",
  },
];

class Myteam extends Component {
  state = {
    loading: true,
    userProfile: "",
    inviteEmail: "",
    inviteEmails: [],
    teamMembers: [],
    totalMemberCount: "",
    currentPage: 1,
    pageSize: 8,
    searchQuery: "",
    groups: [],
    otherGroups: [],
    groupMembers: [],
    groupMemberIDs: [],
    groupName: "",
    groupId: "",
    colorID: 0,
    back: [],
    color: ["#bff603", "yellow", "#80d4ff", "orange"],
    filterTeam: [],
    filterGroup: [],
    filterGroupName: [],
    filterOtherGroup: [],
    selectedMembers: [],
    userFeatures: {},
    myGroupPage: 1,
    otherGroupPage: 1,
    reactTour: false,
    subReqOpen: false,
    inviteAnchorEl: null,
    groupAnchorEl: null,
    adminModalOpen: false,
    sharedModalOpen: false,
  };

  static contextType = ChatContext;

  searchOnChange = (e) => {
    if (e.target.value === "") {
      this.setState({
        filterTeam: this.state.teamMembers,
        filterGroup: this.state.groupMembers,
      });
    } else {
      let value = e.target.value;
      let teamMembers = this.state.teamMembers;
      let groupMembers = this.state.groupMembers;
      let result2 = [];
      let result1 = [];
      result1 = teamMembers.filter((member) => {
        if (member.name.toLowerCase().search(value.toLowerCase()) !== -1) {
          return member;
        }
      });
      result2 = groupMembers.filter((group) => {
        if (group.username.toLowerCase().search(value.toLowerCase()) !== -1) {
          return group;
        }
      });

      this.setState({ filterTeam: result1, filterGroup: result2 });
    }
  };

  handleSearch = (e) => {
    if (e.target.value === "") {
      this.setState({
        filterTeam: this.state.teamMembers,
        filterGroupName: this.state.groups,
        filterOtherGroup: this.state.otherGroups,
      });
    } else {
      let value = e.target.value;
      let teamMembers = this.state.teamMembers;
      let groups = this.state.groups;
      let otherGroups = this.state.otherGroups;

      let result1 = teamMembers.filter((member) => {
        if (member.name.toLowerCase().indexOf(value.toLowerCase()) > -1) {
          return member;
        }
      });

      let result2 = groups.filter((groupmember) => {
        if (groupmember.name.toLowerCase().indexOf(value.toLowerCase()) > -1) {
          return groupmember;
        }
      });

      let result3 = otherGroups.filter((othergroupmember) => {
        if (
          othergroupmember.name.toLowerCase().indexOf(value.toLowerCase()) > -1
        ) {
          return othergroupmember;
        }
      });

      this.setState({
        filterTeam: result1,
        filterGroupName: result2,
        filterOtherGroup: result3,
      });
    }
  };

  async componentDidMount() {
    setTimeout(() => {
      if (this.props.hasAccess === false) {
        this.setState({ subReqOpen: true, loading: false });
      } else {
        this.getTeam();
      }
    }, 2000);
  }

  async componentDidUpdate(prevProps, prevState) {
    if (prevState.groupId !== this.state.groupId) {
      this.setState({ selectedMembers: [] });
    }
  }

  getProfile = async () => {
    let user;
    const { currentUser, setCurrentUser, features } = this.props;
    if (currentUser && !isEmptyObject(currentUser)) {
      user = await userService.getProfile();
      user = user.data;
    } else {
      user = await userService.getProfile();
      user = user.data;
      setCurrentUser(user);
    }
    this.setState({ userProfile: user, userFeatures: features }, () => {
      this.getOtherGroups();
    });
  };

  getOtherGroups = async () => {
    let other = this.state.userProfile.groups;

    if (other.length > 0) {
      const othergroups = await teamService.getGroupById(other);
      this.setState({
        otherGroups: othergroups.data,
        filterOtherGroup: othergroups.data,
      });
    } else {
      this.setState({ otherGroups: [] });
    }
    this.setState({ loading: false });
  };

  getTeam = async () => {
    const teamMembers = await userService.getTeam();
    if (teamMembers.status !== 200) {
      this.setState({ teamMembers: [], filterTeam: [] }, () => {
        this.getGroup();
      });
    } else {
      this.setState(
        {
          filterTeam: teamMembers.data.user,
          teamMembers: teamMembers.data.user,
          totalMemberCount: teamMembers.data.user.length,
        },
        () => {
          this.getGroup();
        }
      );
    }
  };

  getGroup = async () => {
    const group = await teamService.getAllGroups();
    if (group.status === 200) {
      this.setState({ groups: group.data, filterGroupName: group.data }, () => {
        this.getProfile();
      });
    } else {
      this.getProfile();
    }
  };

  handleDelete = async (user) => {
    Swal.fire({
      title: "Are you sure?",
      text: `Do you want to remove this team member`,
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "No, keep it",
    }).then(async (result) => {
      if (result.value === true) {
        this.setState({ loading: true });
        let data = { id: user.id };
        const team = await userService.deleteTeam(data);

        if (team.status === 200) {
          this.getTeam();
          Swal.fire("Deleted!", `${team.message}`, "success");
          const data = {
            userId: sessionStorage.getItem("userId"),
            organizationId: sessionStorage.getItem("organizationId"),
            actionType: "deleteTeamMember",
            userEmail: user.email,
          };
          const addLogs = await addUserLogs(data);
          if (addLogs.status !== 200) {
            toast.error(addLogs.message);
          }
        } else {
          this.setState({ loading: false });
          Swal.fire("Cancelled", `${team.message}`, "error");
        }
      } else {
        Swal.fire("Cancelled", "Your team member is safe :)", "error");
      }
    });
  };

  handlePageChange = (page) => {
    this.setState({ currentPage: page });
  };

  handleSendInvite = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  handleGroupName = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  sendInvite = async (e) => {
    if (this.state.userFeatures?.TeamManagement === false) {
      toast("Please upgrade your plan to enable team member features");
      return;
    }
    this.setState({ loading: true });
    e.preventDefault();
    let email = this.state.inviteEmails;
    if (email.length < 1) {
      this.setState({ loading: false });
      toast.error("Please enter valid email !");
    } else {
      const team = await teamService.inviteMember(email);
      if (team.status !== 200) {
        this.setState({ loading: false });
        toast.error(team.message);
      } else {
        this.setState({ loading: false, inviteAnchorEl: null });
        toast.success(team.message);

        const data = {
          userId: sessionStorage.getItem("userId"),
          organizationId: sessionStorage.getItem("organizationId"),
          actionType: "inviteUser",
          userEmail: email,
        };
        const addLogs = await addUserLogs(data);
        if (addLogs.status !== 200) {
          toast.error(addLogs.message);
        }
      }
    }
    this.setState({ inviteEmails: [] });
  };

  setGroup = async (groupid, groupmembers) => {
    let team = this.state.filterTeam;
    this.setState(
      {
        filterTeam: [],
        groupMembers: [],
        filterGroup: [],
        groupId: groupid,
        loading: true,
      },
      () => this.setState({ filterTeam: team })
    );

    if (groupmembers.length > 0) {
      const groupdata = await teamService.getGroupMembers(groupmembers);
      if (groupdata.status === 200) {
        this.setState({
          groupMembers: groupdata.data,
          filterGroup: groupdata.data,
        });
      }
    }
    this.setState({ loading: false, groupMemberIDs: groupmembers });
  };

  createGroup = async (e) => {
    e.preventDefault();
    if (this.state.userFeatures.TeamManagement === false) {
      toast("Please upgrade your plan to enable team member features");
      return;
    }

    this.setState({ loading: true });
    let currentGroup = this.state.groups;
    let groupName = this.state.groupName;
    let userProfile = this.state.userProfile;
    let match = 0;

    if (groupName === "") {
      this.setState({ loading: false });
      toast.error(`Invalid Group Name!`);
      return;
    }

    if (currentGroup.length > 0) {
      for (let i = 0; i < currentGroup.length; i++) {
        if (groupName === currentGroup[i].name) {
          this.setState({ loading: false, groupName: "" });
          toast(`${groupName} Already exists!`);
          match = 1;
          return;
        }
      }
    }

    if (match === 0) {
      let data = {
        groupname: groupName,
        ownerName: userProfile.username,
      };
      const team = await teamService.createGroup(data);
      if (team.status === 200) {
        this.getGroup();
        toast.success(team.message);
        this.setState({ groupAnchorEl: null });
        const data = {
          userId: sessionStorage.getItem("userId"),
          organizationId: sessionStorage.getItem("organizationId"),
          actionType: "createGroup",
        };
        const addLogs = await addUserLogs(data);
        if (addLogs.status !== 200) {
          toast.error(addLogs.message);
        }
      } else {
        this.setState({ loading: false });
        toast.error(team.message);
      }
    }

    this.setState({ groupName: "" });
  };

  onChangeSelectionBox = (team) => (e) => {
    let selected = this.state.selectedMembers;
    if (e.target.checked === true) {
      selected.push(team.id);
    } else {
      selected.splice(selected.indexOf(team.id), 1);
    }
    this.setState({ selectedMembers: selected });
  };

  addMembersToGroup = async () => {
    let groupMembers = this.state.groupMemberIDs;
    let selectedMembers = this.state.selectedMembers;

    if (selectedMembers.length < 1) {
      toast("No Member selected");
      return;
    } else {
      let presents = _.intersectionWith(
        groupMembers,
        selectedMembers,
        _.isEqual
      );
      if (presents.length > 0) {
        for (let i = 0; i < presents.length; i++) {
          selectedMembers.splice(selectedMembers.indexOf(presents[i]), 1);
        }
      }
    }

    if (selectedMembers.length > 0) {
      let data = {
        memberArray: selectedMembers,
        groupID: this.state.groupId,
      };

      const res = await teamService.addMemberToGroup(data);
      if (res.status === 200) {
        this.getGroup();
        toast.success(res.message);
        this.setState({ adminModalOpen: false });
      } else {
        toast.error(res.message);
      }
      this.setState({ selectedMembers: [] });
      return;
    } else {
      toast("Member already exists");
      return;
    }
  };

  //   addMembersToGroup = async () => {
  //   let groupMembers = this.state.groupMemberIDs;
  //   let selectedMembers = this.state.selectedMembers;

  //   if (selectedMembers.length < 1) {
  //     toast("No Member selected");
  //     return;
  //   }

  //   // Check for duplicates - updated comparison logic
  //   let duplicates = [];
  //   let uniqueSelectedMembers = [];

  //   selectedMembers.forEach(memberId => {
  //     // Check if member is already in the group
  //     if (groupMembers.includes(memberId)) {
  //       duplicates.push(memberId);
  //     } else {
  //       // Check if member is already in the uniqueSelectedMembers array (avoid duplicates in selection)
  //       if (!uniqueSelectedMembers.includes(memberId)) {
  //         uniqueSelectedMembers.push(memberId);
  //       }
  //     }
  //   });

  //   // Update selectedMembers to remove duplicates from selection itself
  //   if (selectedMembers.length !== uniqueSelectedMembers.length) {
  //     this.setState({ selectedMembers: uniqueSelectedMembers });
  //     selectedMembers = uniqueSelectedMembers;
  //   }

  //   // If there are duplicates, show a message
  //   if (duplicates.length > 0) {
  //     // Get member names for better error message
  //     const duplicateMembers = this.state.teamMembers.filter(member =>
  //       duplicates.includes(member.id)
  //     );
  //     const duplicateNames = duplicateMembers.map(member => member.name || member.username).join(', ');

  //     toast.error(`${duplicateNames} ${duplicates.length === 1 ? 'is' : 'are'} already in this group`);

  //     // Remove duplicates from selectedMembers
  //     selectedMembers = selectedMembers.filter(id => !duplicates.includes(id));

  //     if (selectedMembers.length === 0) {
  //       return;
  //     }
  //   }

  //   // If we have unique members to add
  //   if (selectedMembers.length > 0) {
  //     let data = {
  //       memberArray: selectedMembers,
  //       groupID: this.state.groupId,
  //     };

  //     const res = await teamService.addMemberToGroup(data);
  //     if (res.status === 200) {
  //       this.getGroup();
  //       toast.success(res.message);
  //       this.setState({ adminModalOpen: false, selectedMembers: [] });
  //     } else {
  //       toast.error(res.message);
  //     }
  //   }
  // };

  removeMemberFromGroup = async (id) => {
    let data = {
      memberID: id,
      groupID: this.state.groupId,
    };

    const res = await teamService.removeMemberFromGroup(data);
    if (res.status === 200) {
      this.getGroup();
      toast.success(res.message);
    } else {
      toast.error(res.message);
    }
  };

  leaveGroup = async () => {
    this.setState({ loading: true, sharedModalOpen: false });
    let data = {
      _id: this.state.groupId,
    };
    const response = await teamService.leaveGroup(data);
    if (response.status === 200) {
      this.getProfile();
      toast.success(response.message);
    } else {
      toast.error(response.message);
      this.setState({ loading: false });
    }
  };

  deleteGroup = async (group) => {
    Swal.fire({
      title: "Are you sure?",
      text: `Do you want to delete ${group.name}`,
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "No, keep it",
    }).then(async (result) => {
      if (result.value === true) {
        this.setState({ loading: true });
        let data = {
          _id: group._id,
          members: group.members,
        };

        const response = await teamService.deleteGroup(data);
        if (response.status === 200) {
          this.getGroup();
          Swal.fire("Deleted!", `${response.message}`, "success");
          const data = {
            userId: sessionStorage.getItem("userId"),
            organizationId: sessionStorage.getItem("organizationId"),
            actionType: "deleteGroup",
          };
          const addLogs = await addUserLogs(data);
          if (addLogs.status !== 200) {
            toast.error(addLogs.message);
          }
        } else {
          this.setState({ loading: false });
          Swal.fire("Cancelled", `${response.message}`, "error");
        }
      } else {
        Swal.fire("Cancelled", "Your Group is safe :)", "error");
      }
    });
  };

  getPagedData = () => {
    let {
      teamMembers,
      currentPage,
      pageSize,
      searchQuery,
      filterGroupName,
      filterOtherGroup,
    } = this.state;

    let filteredMembers = teamMembers;

    if (searchQuery) {
      filteredMembers = teamMembers.filter((team) =>
        team.name.toLowerCase().startsWith(searchQuery.toLowerCase())
      );
      filterGroupName = filterGroupName.filter((team) =>
        team.name.toLowerCase().startsWith(searchQuery.toLowerCase())
      );
      filterOtherGroup = filterOtherGroup.filter((team) =>
        team.name.toLowerCase().startsWith(searchQuery.toLowerCase())
      );
    }

    const team = paginate(filteredMembers, currentPage, pageSize);
    const myGroups = paginate(filterGroupName, this.state.myGroupPage, 9);
    const otherGroups = paginate(
      filterOtherGroup,
      this.state.otherGroupPage,
      9
    );

    return {
      totalMemberCount: filteredMembers.length,
      teamMembers: team,
      myGroups: myGroups,
      paginateOtherGroups: otherGroups,
      myGroupsCount: filterGroupName.length,
      otherGroupsCount: filterOtherGroup.length,
    };
  };

  handleOpenChat = async (id) => {
    var userProfile = this.state.userProfile;
    try {
      const response = await ChatServices.createContact(userProfile._id, id);
      if (response.status === 200) {
        const { history } = this.props;
        history.push({
          pathname: `/chat`,
        });
      }
    } catch (error) {
      console.error("Error calling backend API:", error.message);
    }
  };

  handleOpenGroupChat = async (groupName, selectedContacts, groupId) => {
    try {
      if (!this.props.hasAccessToChat) {
        this.setState({ subReqOpen: true });
        return;
      }
      const response = await ChatServices.createGroup(
        groupName,
        selectedContacts,
        groupId
      );
      if (response.status === 200) {
        const { history } = this.props;
        history.push({
          pathname: `/chat`,
        });
      }
    } catch (error) {
      console.error("Error calling backend API:", error.message);
    }
  };

  render() {
    let {
      filterTeam,
      filterGroup,
      filterGroupName,
      filterOtherGroup,
      subReqOpen,
      inviteAnchorEl,
      groupAnchorEl,
      adminModalOpen,
      sharedModalOpen,
    } = this.state;

    let {
      teamMembers,
      totalMemberCount,
      myGroups,
      paginateOtherGroups,
      myGroupsCount,
      otherGroupsCount,
    } = this.getPagedData();

    const inviteOpen = Boolean(inviteAnchorEl);
    const groupOpen = Boolean(groupAnchorEl);

    return (
      <Box sx={{ p: 3, bgcolor: "#f5f5f5", minHeight: "100vh" }}>
        <Loader loading={this.state.loading} />
        <SubscriptionRequired
          open={subReqOpen}
          setOpen={(val) => this.setState({ subReqOpen: val })}
        />
        <ToastContainer />

        {/* Header Section */}
        <Paper
          elevation={0}
          sx={{
            p: 3,
            mb: 3,
            borderRadius: 3,
            background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
          }}
        >
          <Grid2 container spacing={2} alignItems="center">
            <Grid2 xs={12} md={6}>
              <SearchTextField
                fullWidth
                placeholder="Search groups or team members..."
                onChange={this.handleSearch}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon sx={{ color: "text.secondary" }} />
                    </InputAdornment>
                  ),
                   sx: { color: "text.secondary", background:"#e7e5e5ff !important" },
                }}
              />
            </Grid2>

            <Grid2 xs={12} md={6}>
              <Box
                sx={{
                  display: "flex",
                  gap: 2,
                  justifyContent: { xs: "flex-start", md: "flex-end" },
                }}
              >
                <ActionButton
                  className="first-step"
                  variant="contained"
                  startIcon={<AddIcon />}
                  onClick={(e) =>
                    this.setState({ groupAnchorEl: e.currentTarget })
                  }
                  sx={{
                    bgcolor: "white",
                    color: "#667eea",
                    "&:hover": { bgcolor: "#f5f5f5" },
                  }}
                >
                  Create Group
                </ActionButton>

                <ActionButton
                  className="second-step"
                  variant="contained"
                  startIcon={<PersonAddIcon />}
                  onClick={(e) =>
                    this.setState({ inviteAnchorEl: e.currentTarget })
                  }
                  sx={{
                    bgcolor: "white",
                    color: "#667eea",
                    "&:hover": { bgcolor: "#f5f5f5" },
                  }}
                >
                  Invite
                </ActionButton>

                <Tooltip title="Need Help?">
                  <IconButton
                    onClick={() => this.setState({ reactTour: true })}
                    sx={{
                      bgcolor: "#e7e3e3ff !important",
                      color: "#4762d8ff !important !important",
                      "&:hover": { bgcolor: "#c6c3c3ff !important" },
                    }}
                  >
                    <HelpIcon />
                  </IconButton>
                </Tooltip>
              </Box>
            </Grid2>
          </Grid2>
        </Paper>
       

        {/* Invite Popover */}
        <Popover
          open={inviteOpen}
          anchorEl={inviteAnchorEl}
          onClose={() => this.setState({ inviteAnchorEl: null })}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "center",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "center",
          }}
        >
          <Box sx={{ p: 3, minWidth: 400 }}>
            <Typography variant="h6" gutterBottom>
              Invite Team Members
            </Typography>
            <ReactMultiEmail
              placeholder="Enter Email addresses"
              emails={this.state.inviteEmails}
              onChange={(_emails) => {
                this.setState({ inviteEmails: _emails });
              }}
              validateEmail={(email) => isEmail(email)}
              getLabel={(email, index, removeEmail) => {
                return (
                  <Chip
                    key={index}
                    label={email}
                    onDelete={() => removeEmail(index)}
                    size="small"
                    color="primary"
                    sx={{ m: 0.5 }}
                  />
                );
              }}
            />
            <Typography
              variant="caption"
              color="text.secondary"
              sx={{ display: "block", mt: 1, mb: 2 }}
            >
              *Multiple invites can be sent
            </Typography>
            <Button
              fullWidth
              variant="contained"
              onClick={this.sendInvite}
              startIcon={<PersonAddIcon />}
            >
              Send Invites
            </Button>
          </Box>
        </Popover>

        {/* Create Group Popover */}
        <Popover
          open={groupOpen}
          anchorEl={groupAnchorEl}
          onClose={() => this.setState({ groupAnchorEl: null })}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "center",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "center",
          }}
        >
          <Box sx={{ p: 3, minWidth: 350 }}>
            <Typography variant="h6" gutterBottom>
              Create New Group
            </Typography>
            <form onSubmit={this.createGroup}>
              <TextField
                fullWidth
                placeholder="Group Title"
                name="groupName"
                value={this.state.groupName}
                onChange={this.handleGroupName}
                sx={{ mb: 2 }}
              />
              <Button
                fullWidth
                variant="contained"
                type="submit"
                startIcon={<GroupIcon />}
              >
                Create Group
              </Button>
            </form>
          </Box>
        </Popover>

        {/* Empty State */}
        {teamMembers.length === 0 &&
        this.state.groups.length === 0 &&
        this.state.otherGroups.length === 0 ? (
          <Box sx={{ textAlign: "center", py: 8 }}>
            <img
              src={team}
              alt="No teams"
              style={{ maxWidth: "400px", opacity: 0.7 }}
            />
            <Typography variant="h5" color="text.secondary" sx={{ mt: 3 }}>
              No teams or groups yet
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
              Create a group or invite team members to get started
            </Typography>
          </Box>
        ) : (
          <>
            {/* Team Members Section */}
            {teamMembers.length > 0 && (
              <Fade in timeout={800}>
                <Box sx={{ mb: 4 }}>
                  <Typography
                    variant="h5"
                    fontWeight={600}
                    gutterBottom
                    sx={{ mb: 3 }}
                  >
                    <GroupIcon
                      sx={{
                        mr: 1,
                        verticalAlign: "middle",
                        color: "primary.main",
                      }}
                    />
                    Team Members
                  </Typography>
                  <Grid2 container spacing={2}>
                    {filterTeam.map((team) => (
                      <Grid2 xs={1} sm={6} md={4} lg={3} key={team.id}>
                        <TeamCard
                          teamdata={team}
                          grpData={this.state.groups}
                          deleteMember={() => this.handleDelete(team)}
                          openChat={() => this.handleOpenChat(team?.id)}
                        />
                      </Grid2>
                    ))}
                  </Grid2>

                  {totalMemberCount > 8 && (
                    <Box
                      sx={{ display: "flex", justifyContent: "center", mt: 3 }}
                    >
                      <PaginatioN
                        activePage={this.state.currentPage}
                        itemsCountPerPage={this.state.pageSize}
                        totalItemsCount={totalMemberCount}
                        pageRangeDisplayed={3}
                        onChange={this.handlePageChange}
                        itemClass="page-item"
                        linkClass="page-link"
                      />
                    </Box>
                  )}
                </Box>
              </Fade>
            )}

            {/* My Groups Section */}
            {this.state.groups.length > 0 && (
              <Fade in timeout={1000}>
                <Box sx={{ mb: 4 }}>
                  <Typography
                    variant="h5"
                    fontWeight={600}
                    gutterBottom
                    sx={{ mb: 3 }}
                  >
                    <GroupIcon
                      sx={{
                        mr: 1,
                        verticalAlign: "middle",
                        color: "primary.main",
                      }}
                    />
                    My Groups
                    <Chip
                      label={`${myGroupsCount} Groups`}
                      size="small"
                      color="primary"
                      variant="outlined"
                      sx={{ ml: 2, fontWeight: 500 }}
                    />
                  </Typography>
                  <Grid2 container spacing={3}>
                    {filterGroupName.length > 0 &&
                      myGroups.map((group, index) => (
                        <Grid2 xs={12} sm={4} md={2} lg={3} key={group._id}>
                          <Zoom in timeout={300 + index * 100}>
                            <StyledCard className="third-step">
                              {/* Card Header with Gradient */}
                              <Box
                                sx={{
                                  background:
                                    "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                                  py: 1.5,
                                  textAlign: "center",
                                  position: "relative",
                                }}
                              >
                                <Box
                                  onClick={() =>
                                    this.setGroup(group._id, group.members)
                                  }
                                  sx={{ cursor: "pointer" }}
                                >
                                  <Box
                                    sx={{
                                      display: "inline-flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      width: 50,
                                      height: 50,
                                      borderRadius: "50%",
                                      bgcolor: "rgba(255,255,255,0.2)",
                                      border: "3px solid rgba(255,255,255,0.3)",
                                    }}
                                  >
                                    <Typography
                                      variant="h5"
                                      fontWeight={700}
                                      color="white"
                                    >
                                      {group.name.charAt(0).toUpperCase()}
                                    </Typography>
                                  </Box>
                                </Box>
                              </Box>

                              <CardContent sx={{ flexGrow: 1, pt: 2 }}>
                                {/* Group Name */}
                                <Typography
                                  variant="h6"
                                  fontWeight={600}
                                  sx={{
                                    mb: 1,
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    whiteSpace: "nowrap",
                                  }}
                                  title={group.name}
                                >
                                  {group.name}
                                </Typography>

                                {/* Admin Info */}
                                <Box
                                  sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    mb: 2,
                                  }}
                                >
                                  <PersonIcon
                                    fontSize="small"
                                    sx={{ mr: 0.5, color: "text.secondary" }}
                                  />
                                  <Typography
                                    variant="body2"
                                    color="text.secondary"
                                  >
                                    Admin:{" "}
                                    <span
                                      style={{
                                        fontWeight: 500,
                                        color: "primary.main",
                                      }}
                                    >
                                      {this.state.userProfile.username}
                                    </span>
                                  </Typography>
                                </Box>

                                {/* Members Count - Fixed to show proper pluralization */}
                                <Chip
                                  icon={<GroupIcon fontSize="small" />}
                                  label={`${group.members.length} ${
                                    group.members.length === 1
                                      ? "member"
                                      : "members"
                                  }`}
                                  size="small"
                                  variant="outlined"
                                  sx={{ mb: 1 }}
                                />
                              </CardContent>

                              {/* Action Buttons */}
                              <CardActions
                                sx={{
                                  p: 1.5,
                                  bgcolor: "black.50",
                                  borderTop: "1px solid",
                                  borderColor: "divider",
                                }}
                              >
                                <Box
                                  sx={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    width: "100%",
                                  }}
                                >
                                  {/* Chat Button */}
                                  <Tooltip title="Open Group Chat">
                                    <Button
                                      variant="contained"
                                      size="small"
                                      startIcon={<ChatIcon />}
                                      onClick={() =>
                                        this.handleOpenGroupChat(
                                          group.name,
                                          group.members,
                                          group._id
                                        )
                                      }
                                      sx={{
                                        borderRadius: 3,
                                        px: 2,
                                        bgcolor: "primary.main",
                                        "&:hover": { bgcolor: "primary.dark" },
                                      }}
                                    >
                                      <Badge
                                        badgeContent={group.unreadCount}
                                        color="error"
                                        sx={{ mr: 1 }}
                                      >
                                        Chat
                                      </Badge>
                                    </Button>
                                  </Tooltip>

                                  {/* Action Buttons Group */}
                                  <Box sx={{ display: "flex", gap: 0.5 }}>
                                    {/* View Members */}
                                    <Tooltip title="View Members">
                                      <IconButton
                                        size="small"
                                        color="primary"
                                        onClick={() => {
                                          this.setGroup(
                                            group._id,
                                            group.members
                                          );
                                          this.setState({
                                            adminModalOpen: true,
                                          });
                                        }}
                                        sx={{
                                          bgcolor: "primary.light",
                                          color: "primary.contrastText",
                                          "&:hover": {
                                            bgcolor: "primary.main",
                                          },
                                        }}
                                      >
                                        <GroupIcon fontSize="small" />
                                      </IconButton>
                                    </Tooltip>

                                    {/* Delete Group - UPDATED WITH RED COLOR */}
                                    {/* <Tooltip title="Delete Group">
                                      <IconButton
                                        size="small"
                                        sx={{
                                          color: "#f44336",
                                          "&:hover": {
                                            color: "#d32f2f",
                                            backgroundColor:
                                              "rgba(244, 67, 54, 0.1)",
                                          },
                                        }}
                                        onClick={() => {
                                          this.removeMemberFromGroup(group._id);
                                          this.setState({
                                            adminModalOpen: false,
                                          });
                                        }}
                                      >
                                        <DeleteIcon />
                                      </IconButton>
                                    </Tooltip> */}
                                    <Tooltip title="Delete Group">
                                      <IconButton
                                        size="small"
                                        onClick={() => {
                                          this.removeMemberFromGroup(group._id);
                                          this.setState({
                                            adminModalOpen: false,
                                          });
                                        }}
                                        sx={{
                                          "& .MuiSvgIcon-root": {
                                            color: "#f44336",
                                          },
                                          "&:hover": {
                                            backgroundColor:
                                              "rgba(244, 67, 54, 0.1)",
                                            "& .MuiSvgIcon-root": {
                                              color: "#d32f2f",
                                            },
                                          },
                                        }}
                                      >
                                        <DeleteIcon />
                                      </IconButton>
                                    </Tooltip>
                                  </Box>
                                </Box>
                              </CardActions>
                            </StyledCard>
                          </Zoom>
                        </Grid2>
                      ))}
                  </Grid2>

                  {/* My Groups Pagination */}
                  {myGroupsCount > 9 && (
                    <Paper
                      elevation={0}
                      sx={{
                        p: 2,
                        mt: 3,
                        borderRadius: 3,
                        bgcolor: "black.50",
                        border: "1px solid",
                        borderColor: "divider",
                      }}
                    >
                      <Box sx={{ display: "flex", justifyContent: "center" }}>
                        <PaginatioN
                          activePage={this.state.myGroupPage}
                          itemsCountPerPage={9}
                          totalItemsCount={myGroupsCount}
                          pageRangeDisplayed={5}
                          onChange={(page) =>
                            this.setState({ myGroupPage: page })
                          }
                          itemClass="page-item"
                          linkClass="page-link"
                          prevPageText={<ArrowBackIcon />}
                          nextPageText={<ArrowForwardIcon />}
                          firstPageText={<FirstPageIcon />}
                          lastPageText={<LastPageIcon />}
                        />
                      </Box>
                    </Paper>
                  )}
                </Box>
              </Fade>
            )}

            {/* Shared Groups Section - If you have this section, apply the same fix */}
            {this.state.otherGroups.length > 0 && (
              <Fade in timeout={1200}>
                <Box sx={{ mb: 4 }}>
                  <Typography
                    variant="h5"
                    fontWeight={600}
                    gutterBottom
                    sx={{ mb: 3 }}
                  >
                    <GroupIcon
                      sx={{
                        mr: 1,
                        verticalAlign: "middle",
                        color: "secondary.main",
                      }}
                    />
                    Shared Groups
                  </Typography>
                  <Grid2 container spacing={3}>
                    {filterOtherGroup.length > 0 &&
                      paginateOtherGroups.map((group, index) => (
                        <Grid2 xs={12} sm={6} md={4} lg={3} key={group._id}>
                          <Zoom in timeout={400 + index * 100}>
                            <StyledCard>
                              {/* Apply the same fix here if needed */}
                              <CardContent sx={{ textAlign: "center", pt: 3 }}>
                                <Box
                                  onClick={() =>
                                    this.setGroup(group._id, group.members)
                                  }
                                  sx={{ cursor: "pointer" }}
                                >
                                  <BasicAvatar
                                    name={group.name.charAt(0).toUpperCase()}
                                    isTeam="team"
                                    colorIndex={
                                      this.state.otherGroups.indexOf(group) % 4
                                    }
                                  />
                                  <Typography
                                    variant="h6"
                                    fontWeight={600}
                                    sx={{ mt: 2, mb: 0.5 }}
                                  >
                                    {group.name}
                                  </Typography>
                                  <Typography
                                    variant="body2"
                                    color="text.secondary"
                                  >
                                    Admin: {group.ownerName}
                                  </Typography>
                                  {/* Apply the same pluralization logic here */}
                                  <Chip
                                    icon={<GroupIcon fontSize="small" />}
                                    label={`${group.members.length} ${
                                      group.members.length === 1
                                        ? "member"
                                        : "members"
                                    }`}
                                    size="small"
                                    variant="outlined"
                                    sx={{ mt: 1 }}
                                  />
                                </Box>
                              </CardContent>
                              <CardActions sx={{ justifyContent: "center" }}>
                                <Button
                                  variant="outlined"
                                  color="primary"
                                  onClick={() => {
                                    this.setGroup(group._id, group.members);
                                    this.setState({ sharedModalOpen: true });
                                  }}
                                >
                                  View Members
                                </Button>
                              </CardActions>
                            </StyledCard>
                          </Zoom>
                        </Grid2>
                      ))}
                  </Grid2>
                </Box>
              </Fade>
            )}
          </>
        )}

        {/* Admin Group Modal - UPDATED WITH RED COLOR */}
        {/* Admin Group Modal - Redesigned UI */}
        <Dialog
          open={adminModalOpen}
          onClose={() => this.setState({ adminModalOpen: false })}
          maxWidth="md"
          fullWidth
          PaperProps={{
            sx: {
              borderRadius: 3,
              overflow: "hidden",
            },
          }}
        >
          <DialogTitle
            sx={{
              bgcolor: "primary.main",
              color: "primary.contrastText",
              p: 3,
              position: "relative",
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                width: "100%",
              }}
            >
              {/* Left Side: Text Content */}
              <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                <GroupIcon fontSize="large" />
                <Box>
                  <Typography variant="h5" fontWeight={700}>
                    Manage Group Members
                  </Typography>
                  <Typography variant="body2" sx={{ opacity: 0.9 }}>
                    Add or remove members from your group
                  </Typography>
                </Box>
              </Box>

              {/* Right Side: Close Button */}
              <IconButton
                onClick={() => this.setState({ adminModalOpen: false })}
                sx={{
                  color: "primary.contrastText",
                  "&:hover": {
                    bgcolor: "rgba(255, 255, 255, 0.1)",
                  },
                }}
              >
                <CloseIcon />
              </IconButton>
            </Box>
          </DialogTitle>

          <DialogContent sx={{ p: 0 }}>
            {/* Search Section */}
            <Paper
              elevation={0}
              sx={{ p: 3, borderBottom: 1, borderColor: "divider" }}
            >
              <SearchTextField
                fullWidth
                placeholder="Search members by name..."
                onChange={this.searchOnChange}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon />
                    </InputAdornment>
                  ),
                  sx: { borderRadius: 2 },
                }}
              />
            </Paper>

            {/* Main Content Grid */}
            <Grid2 container spacing={0} sx={{ height: "60vh" }}>
              {/* Current Members Section */}
              <Grid2
                xs={12}
                md={6}
                sx={{
                  borderRight: { md: 1 },
                  borderColor: "divider",
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <Box
                  sx={{
                    p: 3,
                    borderBottom: 1,
                    borderColor: "divider",
                    bgcolor: "black.50",
                  }}
                >
                  <Typography variant="h6" fontWeight={600} gutterBottom>
                    <Badge
                      badgeContent={filterGroup.length}
                      color="primary"
                      sx={{ mr: 1 }}
                    >
                      Current Members
                    </Badge>
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    Members currently in this group
                  </Typography>
                </Box>

                <Box
                  sx={{
                    flex: 1,
                    overflowY: "auto",
                    p: 2,
                    bgcolor: "background.default",
                  }}
                >
                  {filterGroup.length > 0 ? (
                    <Grid2 container spacing={2}>
                      {filterGroup.map((group) => (
                        <Grid2 xs={12} key={group._id}>
                          <Paper
                            elevation={0}
                            sx={{
                              p: 2,
                              borderRadius: 2,
                              border: "1px solid",
                              borderColor: "divider",
                              transition: "all 0.2s",
                              "&:hover": {
                                borderColor: "primary.main",
                                boxShadow: 1,
                              },
                            }}
                          >
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                              }}
                            >
                              <Box
                                sx={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: 2,
                                }}
                              >
                                <Badge
                                  overlap="circular"
                                  anchorOrigin={{
                                    vertical: "bottom",
                                    horizontal: "right",
                                  }}
                                  variant="dot"
                                  color={
                                    group.status === "online"
                                      ? "success"
                                      : "default"
                                  }
                                >
                                  <Avatar
                                    sx={{
                                      bgcolor:
                                        colors[
                                          filterGroup.indexOf(group) %
                                            colors.length
                                        ],
                                      width: 48,
                                      height: 48,
                                      fontWeight: 600,
                                      fontSize: "1.25rem",
                                    }}
                                  >
                                    {group.username.charAt(0).toUpperCase()}
                                  </Avatar>
                                </Badge>
                                <Box>
                                  <Typography
                                    variant="subtitle1"
                                    fontWeight={600}
                                  >
                                    {group.username}
                                  </Typography>
                                  <Typography
                                    variant="caption"
                                    color="text.secondary"
                                  >
                                    {group.email || "No email provided"}
                                  </Typography>
                                </Box>
                              </Box>

                              <Tooltip title="Remove from group">
                                <IconButton
                                  size="small"
                                  sx={{
                                    color: "error.main",
                                    "&:hover": {
                                      bgcolor: "error.light",
                                      color: "error.dark",
                                    },
                                  }}
                                  onClick={() => {
                                    this.removeMemberFromGroup(group._id);
                                    this.setState({ adminModalOpen: false });
                                  }}
                                >
                                  <DeleteIcon />
                                </IconButton>
                              </Tooltip>
                            </Box>
                          </Paper>
                        </Grid2>
                      ))}
                    </Grid2>
                  ) : (
                    <Box
                      sx={{
                        textAlign: "center",
                        py: 8,
                        color: "text.secondary",
                      }}
                    >
                      <GroupIcon sx={{ fontSize: 60, opacity: 0.3, mb: 2 }} />
                      <Typography variant="h6" gutterBottom>
                        No members in this group
                      </Typography>
                      <Typography variant="body2">
                        Add members from your team list
                      </Typography>
                    </Box>
                  )}
                </Box>
              </Grid2>

              {/* Available Members Section */}
              <Grid2
                xs={12}
                md={6}
                sx={{
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <Box
                  sx={{
                    p: 3,
                    borderBottom: 1,
                    borderColor: "divider",
                    bgcolor: "black.50",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <Box>
                    <Typography variant="h6" fontWeight={600} gutterBottom>
                      Available Members
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      Select members to add to group
                    </Typography>
                  </Box>

                  <Button
                    variant="contained"
                    size="small"
                    onClick={this.addMembersToGroup}
                    disabled={this.state.selectedMembers.length === 0}
                    startIcon={<PersonAddIcon />}
                    sx={{
                      borderRadius: 2,
                      fontWeight: 600,
                      px: 3,
                    }}
                  >
                    Add ({this.state.selectedMembers.length})
                  </Button>
                </Box>

                <Box
                  sx={{
                    flex: 1,
                    overflowY: "auto",
                    p: 2,
                    bgcolor: "background.default",
                  }}
                >
                  {filterTeam.length > 0 ? (
                    <Grid2 container spacing={2}>
                      {filterTeam.map((team) => (
                        <Grid2 xs={12} key={team.id}>
                          <Paper
                            elevation={0}
                            sx={{
                              p: 2,
                              borderRadius: 2,
                              border: "1px solid",
                              borderColor: this.state.selectedMembers.includes(
                                team.id
                              )
                                ? "primary.main"
                                : "divider",
                              bgcolor: this.state.selectedMembers.includes(
                                team.id
                              )
                                ? "primary.lighter"
                                : "background.paper",
                              transition: "all 0.2s",
                              cursor: "pointer",
                              "&:hover": {
                                borderColor: "primary.main",
                                bgcolor: "action.hover",
                              },
                            }}
                            onClick={() => {
                              const isSelected =
                                this.state.selectedMembers.includes(team.id);
                              let selected = [...this.state.selectedMembers];

                              if (isSelected) {
                                selected = selected.filter(
                                  (id) => id !== team.id
                                );
                              } else {
                                selected.push(team.id);
                              }

                              this.setState({ selectedMembers: selected });
                            }}
                          >
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                gap: 2,
                              }}
                            >
                              <Checkbox
                                color="primary"
                                checked={this.state.selectedMembers.includes(
                                  team.id
                                )}
                                onChange={this.onChangeSelectionBox(team)}
                                onClick={(e) => e.stopPropagation()}
                                sx={{
                                  "&.Mui-checked": {
                                    color: "primary.main",
                                  },
                                }}
                              />

                              <Badge
                                overlap="circular"
                                anchorOrigin={{
                                  vertical: "bottom",
                                  horizontal: "right",
                                }}
                                variant="dot"
                                color={
                                  team.status === "online"
                                    ? "success"
                                    : "default"
                                }
                              >
                                <Avatar
                                  sx={{
                                    bgcolor:
                                      colors[
                                        filterTeam.indexOf(team) % colors.length
                                      ],
                                    width: 48,
                                    height: 48,
                                    fontWeight: 600,
                                    fontSize: "1.25rem",
                                  }}
                                >
                                  {team.name.charAt(0).toUpperCase()}
                                </Avatar>
                              </Badge>

                              <Box sx={{ flex: 1 }}>
                                <Typography
                                  variant="subtitle1"
                                  fontWeight={600}
                                >
                                  {team.name || "-"}
                                </Typography>
                                <Typography
                                  variant="caption"
                                  color="text.secondary"
                                >
                                  {team.email || "No email provided"}
                                </Typography>
                              </Box>

                              {this.state.selectedMembers.includes(team.id) && (
                                <Chip
                                  label="Selected"
                                  color="primary"
                                  size="small"
                                  variant="outlined"
                                  icon={<PersonAddIcon fontSize="small" />}
                                />
                              )}
                            </Box>
                          </Paper>
                        </Grid2>
                      ))}
                    </Grid2>
                  ) : (
                    <Box
                      sx={{
                        textAlign: "center",
                        py: 8,
                        color: "text.secondary",
                      }}
                    >
                      <PersonIcon sx={{ fontSize: 60, opacity: 0.3, mb: 2 }} />
                      <Typography variant="h6" gutterBottom>
                        No team members available
                      </Typography>
                      <Typography variant="body2">
                        Invite team members to get started
                      </Typography>
                    </Box>
                  )}
                </Box>
              </Grid2>
            </Grid2>
          </DialogContent>

          <DialogActions
            sx={{
              p: 3,
              borderTop: 1,
              borderColor: "divider",
              justifyContent: "space-between",
            }}
          >
            <Box sx={{ display: "flex", gap: 1 }}>
              <Chip
                icon={<GroupIcon />}
                label={`${filterGroup.length} members in group`}
                color="primary"
                variant="outlined"
              />
              <Chip
                icon={<PersonIcon />}
                label={`${filterTeam.length} available members`}
                variant="outlined"
              />
            </Box>

            <Box sx={{ display: "flex", gap: 2 }}>
              <Button
                variant="outlined"
                onClick={() => this.setState({ adminModalOpen: false })}
                sx={{ borderRadius: 2 }}
              >
                Cancel
              </Button>
              <Button
                variant="contained"
                onClick={this.addMembersToGroup}
                disabled={this.state.selectedMembers.length === 0}
                startIcon={<PersonAddIcon />}
                sx={{ borderRadius: 2 }}
              >
                Add Selected Members
              </Button>
            </Box>
          </DialogActions>
        </Dialog>

        {/* Shared Group Modal */}
        <Dialog
          open={sharedModalOpen}
          onClose={() => this.setState({ sharedModalOpen: false })}
          maxWidth="sm"
          fullWidth
        >
          <DialogTitle>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <Typography variant="h6">Group Members</Typography>

              <IconButton
                onClick={() => this.setState({ sharedModalOpen: false })}
                sx={{
                  "& .MuiSvgIcon-root": {
                    color: "#f44336",
                  },
                  "&:hover": {
                    backgroundColor: "rgba(244, 67, 54, 0.1)",
                  },
                }}
              >
                <CloseIcon />
              </IconButton>
            </Box>
          </DialogTitle>
          <DialogContent dividers>
            <TextField
              fullWidth
              placeholder="Search username or group"
              onChange={this.searchOnChange}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                ),
              }}
              sx={{ mb: 3 }}
            />

            <Box sx={{ maxHeight: "40vh", overflowY: "auto" }}>
              {filterGroup.length > 0 ? (
                filterGroup.map((group) => (
                  <Box
                    key={group._id}
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 2,
                      p: 1.5,
                      mb: 1,
                      borderRadius: 2,
                      "&:hover": { bgcolor: "action.hover" },
                    }}
                  >
                    <Avatars
                      name={group.username.charAt(0).toUpperCase()}
                      status={group.status}
                      colorIndex={filterGroup.indexOf(group) % 4}
                      size={40}
                    />
                    <Typography fontWeight={500}>{group.username}</Typography>
                  </Box>
                ))
              ) : (
                <Typography color="text.secondary" align="center">
                  No members found
                </Typography>
              )}
            </Box>
          </DialogContent>
          <DialogActions sx={{ p: 2 }}>
            <Button
              variant="contained"
              startIcon={<ExitToAppIcon />}
              onClick={() => this.leaveGroup()}
              sx={{
                backgroundColor: "error.main",
                "&:hover": {
                  backgroundColor: "error.dark",
                },
              }}
            >
              Leave Group
            </Button>
            <Button onClick={() => this.setState({ sharedModalOpen: false })}>
              Close
            </Button>
          </DialogActions>
        </Dialog>

        <ReactTour
          steps={this.state.groups.length > 0 ? stepsone : steps}
          isOpen={this.state.reactTour}
          closeTour={() => this.setState({ reactTour: false })}
        />
      </Box>
    );
  }
}

const mapStateToProps = (state) => ({
  currentUser: state.user.currentUser,
  features: state.features.features,
});

const mapDispatchToProps = (dispatch) => ({
  setCurrentUser: (user) => dispatch(setCurrentUser(user)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Myteam));
